import { useSearchParams } from "react-router-dom";
import { QueryParams } from "../models/CommonModel";
import { stringToBoolean } from "../utils/appUtils";

export interface QueryObj {
  userId: string;
  storeNo: string;
  userType: string;
  authToken: string;
  rscCd: string;
  skuNumber: string;
  shipToCustomerPermission: string;
  discoveryPermission: string;
  everydayDropshipPermission: string;
  cpoPermission: string;
  stockReservePermission: boolean;
}

const useQueryParams = (): QueryParams => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const storeNo = searchParams.get("storeNo");
  const userType = searchParams.get("userType");
  const authToken = searchParams.get("authToken");
  const rscCd = searchParams.get("rscCd");
  const skuNumber = searchParams.get("sku");
  const shipToCustomerPermission = searchParams.get("shipToCustomerPermission");
  const everydayDropshipPermission = searchParams.get(
    "everydayDropshipPermission"
  );
  const discoveryPermission = searchParams.get("discoveryPermission");
  const cpoPermission = searchParams.get("cpoPermission");
  const stockReservePermission = stringToBoolean(
    searchParams.get("stockReservePermission")
  );

  const queryObj: QueryObj = {
    userId,
    storeNo,
    userType,
    authToken,
    rscCd,
    skuNumber,
    shipToCustomerPermission,
    discoveryPermission,
    everydayDropshipPermission,
    cpoPermission,
    stockReservePermission,
  };
  return {
    queryObj,
    userId,
    storeNo,
    userType,
    authToken,
    rscCd,
    skuNumber,
    shipToCustomerPermission,
    discoveryPermission,
    everydayDropshipPermission,
    cpoPermission,
    stockReservePermission,
  };
};

export default useQueryParams;
